import { Viewer, XKTLoaderPlugin } from "@xeokit/xeokit-sdk";
import Model from "../../Models/Model";
import ViewerConfig from "@/Models/ViewerConfig";

export enum ActionType {
  SetViewer,
  SetModels,
  ClearModels,
  AddModel,
  SetLoaderPlugin,
  SetViewerConfig,
}
export interface SetModels {
  type: ActionType.SetModels;
  models: Model[];
}
export interface ClearModels {
  type: ActionType.ClearModels;
}
export interface AddModel {
  type: ActionType.AddModel;
  model: Model;
}
export interface SetViewer {
  type: ActionType.SetViewer;
  viewer: Viewer | null;
}

export interface SetLoaderPlugin {
  type: ActionType.SetLoaderPlugin;
  loaderPlugin: XKTLoaderPlugin | null;
}

export interface SetViewerConfig {
  type: ActionType.SetViewerConfig;
  viewerConfig: ViewerConfig;
}

export type XktActions =
  | SetViewer
  | SetModels
  | ClearModels
  | AddModel
  | SetLoaderPlugin
  | SetViewerConfig;
